import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'environments/environment';

import { LoginMessage } from '@model';
import { SxErrorService } from 'app/services/sx-error.service';

@Injectable({
  providedIn: 'root'
})
export class LoginMessagesService {
  constructor(private http: HttpClient, private sxErrorService: SxErrorService) {}

  getLoginMessages(): Observable<LoginMessage[]> {
    return this.http
      .get<LoginMessage[]>(`${environment.apiEndpoint}/information/loginMessages`)
      .pipe(catchError((error: any) => this.sxErrorService.handleError(error)));
  }
}
